import htmx from 'htmx.org';
import { Idiomorph } from 'idiomorph'

Idiomorph.defaults.callbacks.beforeNodeMorphed = (oldNode, _newNode) => {
  if (oldNode.nodeType === Node.ELEMENT_NODE && oldNode.hasAttribute("morph-preserve")) {
    return false;
  }
}
Idiomorph.defaults.callbacks.beforeAttributeUpdated = (attributeName, node, _mutationType) => {
  const attrsToPreserve = node.getAttribute("morph-preserve-attrs");
  if (attrsToPreserve && attrsToPreserve.split(/\s+/).includes(attributeName)) {
    return false;
  }
}
Idiomorph.defaults.callbacks.afterNodeMorphed = (oldNode, _newNode) => {
  if (oldNode.nodeType === Node.ELEMENT_NODE && oldNode.hasAttribute("morph-notify")) {
    oldNode.dispatchEvent(new CustomEvent('morphed'))
  }
}

const idiomorphConfig = { morphStyle: 'outerHTML' };

htmx.defineExtension('morph', {
  isInlineSwap: function() {
      return true;
  },
  handleSwap: function (swapStyle, target, fragment) {
      return Idiomorph.morph(target, fragment.children, idiomorphConfig);
  }
});

htmx.on('htmx:beforeSwap', function (e) {
  if(e.detail.isError) {
    const main = document.querySelector('main[role="main"]')
    e.detail.target = main
    e.detail.shouldSwap = true
    e.detail.isError = false
    e.detail.selectOverride = 'main[role="main"]'
  }
});

htmx.on('htmx:configRequest', function (e) {
  // HTMX doesn't repect attribute changes on boosted elements (href for links, actions for forms etc)
  // If the request is boosted, set the correct values based on the trigger's attributes
  if(e.detail.boosted) {
    if (e.detail.elt instanceof HTMLFormElement) {
      const action = e.detail.elt.getAttribute('action')
      e.detail.path = (action ? action : location.href)
      const method = e.detail.elt.getAttribute('method')
      e.detail.verb = (method ? method.toLowerCase() : 'get')
      e.detail.useUrlParams = e.detail.verb === 'get'
    }
    else if (e.detail.elt instanceof HTMLAnchorElement) {
      e.detail.path = e.elt.getAttribute('href')
    }
  }
})

htmx.config.historyCacheSize = 0;
